import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import './style.css';

class Main extends React.Component {

    render() {
        return (
            /* page content */
            <div className="right-col" role="main">
                <div className="page-title">
                    <h3>Hlavní stránka</h3>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

export default withRouter(connect(mapStateToProps)(Main));



/** WEBPACK FOOTER **
 ** ./src/containers/Main/index.js
 **/